<template>
  <div class="membership">
    <div class="membership__left-col">
      <avatar
        :name="user | fullName"
        size="md"
        class="avatar"
      />

      <div>
        <div class="membership__name">
          {{ user | fullName }}
        </div>
        <div class="membership__email">{{ user.email }}</div>
      </div>
    </div>

    <div class="membership__right-col">
      <div
        v-t="'c.teamMember.label.owner'"
        v-if="membership.role == 'owner'"
        class="membership__owner-label"
      />
      <div
        v-else
        class="membership__actions"
      >
        <dropdown-input
          v-if="membership.active"

          :options="roleDropdownOptions"
          position="right"
          theme="primary"
          @select="handleRoleDropdownSelect"
        >
          <button-input
            size="full"
            class="membership__role"
          >
            <span class="text-sm font-semibold">
              {{ $t(`c.clientMember.label.${userRole}`) }}
            </span>
            <font-awesome-icon icon="angle-down" />
          </button-input>
        </dropdown-input>

        <div class="membership__active">
          <button-input
            :color="activeState"
            size="square"
            @click="updateState"
          >
            <font-awesome-icon
              icon="check"
            />
          </button-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import fullName from '@/filters/fullName'
import FormMixin from '@/mixins/forms/Form'
import Avatar from '@/components/ui/Avatar'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Membership',
  mixins: [FormMixin],
  components: {
    Avatar,
    FontAwesomeIcon
  },
  filters: {
    fullName
  },
  props: {
    membership: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      role: 'editor'
    }
  },
  computed: {
    user () {
      return this.membership.user
    },
    userRole: {
      get () { return this.role },
      set (role) { this.role = role }
    },
    roleDropdownOptions () {
      return [
        { label: this.$t('c.clientMember.label.admin'), value: 'admin' },
        { label: this.$t('c.clientMember.label.editor'), value: 'editor' },
        { label: this.$t('c.clientMember.label.reader'), value: 'reader' }
      ]
    },
    activeState () {
      return this.membership.active ? 'normal' : 'grey'
    }
  },
  methods: {
    ...mapActions([
      'updateMembershipRole',
      'updateMembershipState'
    ]),
    handleRoleDropdownSelect ({ value }) {
      switch (value) {
        default:
          this.role = value
          this.updateMembershipRole({
            membership: this.membership,
            role: value
          }).then(() => {
            this.$emit('roleChange')
          })
      }
    },
    updateState () {
      this.updateMembershipState({
        membership: this.membership
      }).then(() => {
        this.$emit('roleChange')
      })
    }
  },
  mounted () {
    this.role = this.$props.membership.role
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/imports'

.membership
  position: relative;
  border-top: 1px solid #E1E6EB;
  border-bottom: 1px solid #E1E6EB;
  height: rem-calc(100);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__left-col,
  &__right-col
    display: flex;
    align-items: center;

  &__actions
    display: flex

  &__owner-label
    +font-size(15, 42);
    text-align: center;
    width: rem-calc(100);
    height: rem-calc(42);
    background: $color-grey-1;
    border-radius: 3px;
    display: inline-block;
    cursor: default;

  &__name
    +font-size(15, 15);
    font-family: $font-1;
    margin-bottom: rem-calc(5);
    font-weight: 500;

  &__link
    color: #000;

  &__active
    margin-left: rem-calc(10);

  &__role
    min-width: rem-calc(120)

  &__email
    +font-size(12, 14)
    color: $color-grey-2;

.membership + .membership
  border-top: 0;

.avatar
  margin-right: rem-calc(15);

.radio-bar-input
  display: inline-flex;
  margin-right: rem-calc(10);
</style>





// WEBPACK FOOTER //
// src/components/teams/TeamMember.vue